import { Injectable } from '@angular/core';
import { DefaultPersistenceResultHandler, EntityAction } from '@ngrx/data';
import { Action } from '@ngrx/store';
import { isArray } from 'lodash-es';

@Injectable()
export class AdditionalPersistenceResultHandler extends DefaultPersistenceResultHandler {
  override handleSuccess(originalAction: EntityAction): (data: any) => Action {
    const actionHandler = super.handleSuccess(originalAction);
    // return a factory to get a data handler to
    // parse data from DataService and save to action.payload
    return function (this: unknown, data: any) {
      const action = actionHandler.call(this, data);

      if (action && data) {
        if (data.items) {
          (action as any).payload.data = [
            ...(data.items ?? []),
            ...(data.pinnedItems ?? []),
          ];

          const pinnedItemsCount = data.pinnedItems?.length ?? 0;

          (action as any).payload.itemsCount =
            data.itemsCount + pinnedItemsCount;
          (action as any).payload.totalItemsCount = data.totalItemsCount ?? 0;
          (action as any).payload.pinnedItems = data.pinnedItems ?? [];
        } else if (isArray(data)) {
          (action as any).payload.data = data;
        }
      }

      return action;
    };
  }
}
